import { gql } from '@apollo/client'

export const GET_GUEST_CARD_OPTIONS = gql`
  query GetGuestCardFormOptions($propertyId: Int!) {
    createGuestCardFormOptions(property_id: $propertyId)
  }
`
export const GET_GUEST_CARD_PROPERTIES = gql`
  query GetGuestCardProperties {
    guestCardProperties
  }
`
